<template>
    <div>
        <modal :show.sync="show" v-if="showHack">
            <div class="modal-header"
                 slot="modal-header">
                <h4 v-if="contactName">
                    {{ contact.title | shortTitle }}
                    {{ contactName }}
                </h4>
                <h4 v-if="!contactName">
                    Édition/Ajout de contact
                </h4>
            </div>

            <div class="modal-body"
                 slot="modal-body">
                <person-form :data.sync="contact" :is-company-contact="true"
                             :valid.sync="formValid"></person-form>
            </div>

            <div class="modal-footer"
                 slot="modal-footer">
                <button @click.prevent="show = false"
                        class="btn btn-link">
                    Annuler
                </button>
                <button @click.prevent="saveContact(contact)"
                        :class="{disabled: !formValid}"
                        class="btn btn-primary">
                    Sauvegarder
                </button>
            </div>
        </modal>
    </div>
</template>

<style lang="less" type="text/less" scoped>
</style>

<script>
    import PersonForm from '../clients/PersonForm';
    import Modal from 'vue-strap/src/Modal';
    import {dataToContact, contactToData} from '../clients/utils';

    export default {
        components: {
            PersonForm,
            Modal
        },
        data() {
            return {
                contact: Object,
                formValid: false,
                show: false,
                showHack: false
            };
        },
        props: {
            saveContact: Function
        },
        methods: {
            dataToContact(contact) { return dataToContact(contact); }
        },
        events: {
            /**
             * Open the modal
             * @param contact
             */
            'show-edit-contact-modal': function (contact) {
                this.showHack = true;
                this.contact = contactToData(contact);
                this.show = true;
            }
        },
        name: 'edit-contact-modal'
    };
</script>



// WEBPACK FOOTER //
// EditContactModal.vue?81c74c92